import React, { useMemo } from 'react';
import { ActivityType, Box, CategoryIcon, List, ShimmerBox } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { EMPTY_FIELD_VALUE, SHORT_DATE_FORMAT } from '@/common/constants';
import { LettersOfMedicalNecessity, LMNClaim } from '@/modules/MyDocuments/myDocuments.types';
import { Service } from '@/modules/MyDocuments/queries/useGetClaimServices.query';
import { formatCurrency } from '@/utils';

import { LettersOfMedicalNecessityClaims } from '../LettersOfMedicalNecessityClaims/LettersOfMedicalNecessityClaims';

interface Props extends LettersOfMedicalNecessity {
  claim: LMNClaim;
  service?: Service;
  isLoading?: boolean;
  isMobile?: boolean;
}

const LettersOfMedicalNecessityClaimListItem: React.FC<Props> = ({
  claim,
  service,
  isLoading,
  isMobile,
}) => {
  const formattedDate = useMemo(() => {
    if (!claim.serviceOn) return EMPTY_FIELD_VALUE;

    return dayjs(claim.serviceOn).format(SHORT_DATE_FORMAT);
  }, [claim.serviceOn]);

  if (isLoading) {
    return (
      <ShimmerBox height='76px' width='100%' margin={{ top: 'spacing8' }} />
    );
  }

  if (isMobile) {
    return (
      <List.Item 
        pad="spacing12"
        gap="spacing8"
        testId="lmn-claim-list_item"
      >
        <List.Item.Text flex={2}>
          <Box direction="row" align="center" gap="spacing12">
            <CategoryIcon category={service?.categoryType as ActivityType}/>
            <LettersOfMedicalNecessityClaims claim={claim} />
          </Box>
        </List.Item.Text>
        <Box direction="column">
          <List.Item.Text weight={400} flex={1.2} textAlign="end">
            {formatCurrency(claim.requestedAmount)}
          </List.Item.Text>
      
          <List.Item.Text weight={400} flex={0.8} color="textSecondary" textAlign="end">
            {formattedDate}
          </List.Item.Text>
        </Box>
      </List.Item>
    );
  }

  return (
    <List.Item
      pad={{ vertical: "spacing12", horizontal: "spacing24" }}
      testId="lmn-claim-list_item"
      gap="spacing8"
    >
      <List.Item.Text flex={2}>
        <Box direction="row" align="center" gap="spacing12">
          <CategoryIcon category={service?.categoryType as ActivityType}/>
          <LettersOfMedicalNecessityClaims claim={claim} />
        </Box>
      </List.Item.Text>

      <List.Item.Text weight={400} flex={1.2} size='16px'>
        {formatCurrency(claim.requestedAmount)}
      </List.Item.Text>
  
      <List.Item.Text weight={400} flex={0.8} size="16px" color="textSecondary">
        {formattedDate}
      </List.Item.Text>

    </List.Item>
  );
};

export default LettersOfMedicalNecessityClaimListItem;
